﻿import type { SectionHeadingComponent } from "../../types";

/** Section heading (h2) renderer with Aleo styling. On mobile the weight drops to
 *  medium: the Aleo serif in semibold reads too heavy on small screens, especially
 *  for the long article-intro headings. */
export function SectionHeadingRenderer({ component }: { component: SectionHeadingComponent }) {
  const { text, size } = component.content;
  // `size` était déclaré dans le type mais IGNORÉ : toutes les têtes de rubrique
  // sortaient à la taille « medium », d'où l'écart avec les pages de section codées
  // en dur (/statistiques). « large » reprend exactement leur échelle
  // (text-2xl md:text-3xl) pour que les deux familles de pages s'alignent.
  const className =
    size === "large"
      ? "mb-2 text-2xl font-bold leading-tight text-[#005CA9] md:mb-3 md:text-3xl lg:mb-4"
      : "mb-2 text-xl font-bold leading-tight text-[#005CA9] md:mb-3 md:text-[1.35rem] lg:mb-4 xl:text-2xl";
  return (
    <h2 className={className} style={{ fontFamily: "var(--font-aleo)" }}>
      {text}
    </h2>
  );
}

